import React, { useEffect, useState } from 'react';
import api, { asArray } from '../services/api';
import { PageHeader, DarkPanel, SearchBox } from '../components/ui';

export default function News() {
  const [news, setNews] = useState([]);
  // Defaults to SPY news (the broad market) — also used when the filter is cleared
  const [tickers, setTickers] = useState('SPY');
  const [shown, setShown] = useState('SPY');
  const [loading, setLoading] = useState(true);

  const load = (t) => {
    setLoading(true);
    const sym = (t || '').trim() || 'SPY';
    setShown(sym);
    api.get(`/stock/news?tickers=${encodeURIComponent(sym)}&limit=20`)
      .then(r => setNews(asArray(r.data)))
      .catch(() => setNews([]))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load('SPY'); }, []);

  const sentimentColor = (s) => {
    if (!s) return 'text-slate-500';
    if (s.toLowerCase().includes('bull')) return 'text-emerald-400';
    if (s.toLowerCase().includes('bear')) return 'text-rose-400';
    return 'text-slate-400';
  };

  return (
    <div className="pb-8">
      <PageHeader title="Market News" />

      <SearchBox
        value={tickers}
        onChange={setTickers}
        onSubmit={load}
        placeholder="Search news by symbol, e.g. AAPL"
        busy={loading}
        allowEmpty
        className="mb-4 max-w-md"
      />

      <DarkPanel title={`News · ${shown}`} bodyClassName="space-y-1.5 p-2.5">
        {loading ? (
          <p className="py-12 text-center text-sm text-slate-400">Loading news…</p>
        ) : news.length === 0 ? (
          <p className="py-12 text-center text-sm text-slate-400">No news found. Try again later.</p>
        ) : (
          news.map((n, i) => (
            <a
              key={i}
              href={n.url}
              target="_blank"
              rel="noreferrer"
              className="block rounded-xl border border-white/5 bg-white/[0.03] p-3.5 transition hover:bg-white/[0.06]"
            >
              <div className="flex justify-between gap-3">
                <h3 className="text-sm font-semibold leading-snug text-white">{n.title}</h3>
                <span className={`shrink-0 text-[11px] font-medium ${sentimentColor(n.sentiment)}`}>
                  {n.sentiment || ''}
                </span>
              </div>
              {n.summary && (
                <p className="mt-1.5 line-clamp-2 text-xs text-slate-400">{n.summary}</p>
              )}
              <div className="mt-2 flex flex-wrap gap-2 text-[11px] text-slate-500">
                <span>{n.source}</span>
                {n.time && <span>· {n.time.replace(/(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2})/, '$1-$2-$3 $4:$5')}</span>}
                {(n.tickers || []).slice(0, 4).map(t => (
                  <span key={t} className="rounded bg-white/10 px-1.5 py-0.5 text-slate-300">{t}</span>
                ))}
              </div>
            </a>
          ))
        )}
      </DarkPanel>
    </div>
  );
}
